import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Alert,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Delaware from "./Delaware";
import Florida from "./Florida";
import Flatpickr from "react-flatpickr";
import * as Yup from "yup";
import { useFormik } from "formik";
import DatePicker from "react-datepicker";
import {
  createHicContract,
  getSingleProjectById,
  sendDocToS3,
  geCompanyData,
} from "../../../../slices/thunk";
import { useSelector, useDispatch } from "react-redux";
import "react-datepicker/dist/react-datepicker.css";
import Massuchusetts from "./Massuchusetts";
import OhioContractFields from "./OhioContractFields";

import Dropzone from "react-dropzone";
import { useTranslation } from "react-i18next";
import Table from 'quill-table-ui';
import DocumentAI from "./document-ai";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import RichEditorTipTab from "ractTable";
import { CallAPIPostPromise } from "Common/commaon";
import { Toaster, toast } from "sonner";
import LoaderModal from "Layout/loader";
import axios from "axios";
import apiUrl from "slices/apiEndpoint";
import ProcessingModal from "./streamModal";
import { DocumentLoader } from "./documentLoader";
import { ContractLoadingModal } from "components/contractLoadingModal";
import { CalendarDays, CheckCircle2, DollarSign, FileText, Loader2, MapPin, ShieldCheck, UploadCloud, UsersRound } from "lucide-react";
import { clearLoganProjectScope, loadLoganProjectScope, LoganProjectDraft } from "features/productAssistant/projectDraft";







interface AddContractProps {
  closeModal: (type: "created" | "draft") => void;
  afterCreate:()=> void
  assistantSnapshot?: Partial<LoganProjectDraft>;
  onAssistantSnapshotChange?: (snapshot: Partial<LoganProjectDraft>) => void;
}

function toDateValue(value: unknown) {
  if (!value) return "";
  const date = value instanceof Date ? value : new Date(String(value));
  return Number.isNaN(date.getTime()) ? "" : date.toISOString().slice(0, 10);
}

const AddContract: React.FC<AddContractProps> = ({ closeModal, afterCreate, assistantSnapshot, onAssistantSnapshotChange }) => {
  const [showStreamModal,setShowStreamModal]=useState(false)
  const [streamProcessing,setStreamProcessing]=useState(false)
  const project = useSelector((state: any) => state.Contract.project);
  const loganProjectScope = loadLoganProjectScope(project?.p_id || "");
  const [preview, setPreview] = useState<string | null>(null);
  const [fileName, setFileName] = useState<string | null>(null);
  const [currentStage, setCurrentStage] = useState<any>('uploading');
  const [extractorType,setExtrctorType]=useState('1')
  const [selectedState, setSelectedState] = useState(
    project?.contract?.pc_state || ""
  );
const [scopeUrl,setScopeUrl] = useState("")
  const company = useSelector((state: any) => state.ContractorCompany.company);
  const parseSavedExtraData = () => {
    try {
      const saved = project?.contract?.pc_extra_data;
      const parsed = typeof saved === "string" ? JSON.parse(saved || "{}") : saved;
      return parsed && typeof parsed === "object" && !Array.isArray(parsed)
        ? parsed
        : {};
    } catch (_) {
      return {};
    }
  };
  const [ohioData, setOhioData] = useState<Record<string, any>>(
    () => parseSavedExtraData().ohio || {}
  );
  const [federalTaxId, setFederalTaxId] = useState(
    project?.contract?.pc_federal_tax_id || ""
  );
  const [file, setFile] = useState<any>(null);
  const [extraData, setExtradata] = useState<Record<string, any>>(
    () => parseSavedExtraData()
  );
  const dispatch: any = useDispatch();
  let data = null;
  const [extractedHTML,setExtractedHTML] = useState("")
  const [loading, setLoading] = useState<boolean>(false);
  const [draftLoading, setDraftLoading] = useState<boolean>(false);
  const applyingAssistantSnapshotRef = useRef(false);
  const assistantSyncFrameRef = useRef<number | null>(null);
  const [notification, setNotification] = useState<{
    status: boolean;
    message: string;
    variant: "success" | "danger" | "warning" | "info";
  } | null>(null);
 const [missingField,setMissingField]=useState("")
  const handleExtraData = (data: object) => {
    setExtradata(data);
  };
  useEffect(() => {
    dispatch(geCompanyData());
  }, [dispatch]);

  useEffect(() => {
    if (!federalTaxId && company?.cc_federal_tax_id) {
      setFederalTaxId(String(company.cc_federal_tax_id).replace(/\D/g, ""));
    }
  }, [company, federalTaxId]);
  const [isLoading, setIsLoading] = useState(true);
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);
  const [hasReviewed, setHasReviewed] = useState(false);
  const [currentTip, setCurrentTip] = useState(0);
  useEffect(() => {
    if (notification && notification.status) {
      const timer = setTimeout(() => {
        setNotification(null);
      }, 5000);

      // Cleanup the timeout if the component unmounts or notification changes
      return () => clearTimeout(timer);
    }
  }, [notification]);

  const handleAlertClick = () => {
    setNotification(null);
  };
  const validationSchema = Yup.object().shape({
    additionalHomeownerName: Yup.string(),
    startDate: Yup.date()
      .nullable()
      .transform((value, originalValue) =>
        originalValue === null || originalValue === "" ? null : value
      )
      .min(new Date(), "Start date cannot be in the past")
      .required("Start date is required"),

    substantialCompletionDate: Yup.date()
      .nullable()
      .transform((value, originalValue) =>
        originalValue === null || originalValue === "" ? null : value
      )
      .required("Substantial completion date is required")
      .when("startDate", (startDate, schema) =>
        startDate && startDate instanceof Date && !isNaN(startDate.getTime())
          ? schema.min(
              startDate,
              "Substantial completion date cannot be before start date"
            )
          : schema
      ),

    endDate: Yup.date()
      .nullable()
      .transform((value, originalValue) =>
        originalValue === null || originalValue === "" ? null : value
      )
      .required("End date is required")
      .when("startDate", (startDate, schema) =>
        startDate && startDate instanceof Date && !isNaN(startDate.getTime())
          ? schema.min(startDate, "End date cannot be before start date")
          : schema
      )
      .when("substantialCompletionDate", (substantialCompletionDate, schema) =>
        substantialCompletionDate &&
        substantialCompletionDate instanceof Date &&
        !isNaN(substantialCompletionDate.getTime())
          ? schema.min(
              substantialCompletionDate,
              "End date cannot be before substantial completion date"
            )
          : schema
      ),
    projectCostModel: Yup.string().required("Project cost model is required"),
    allowances: Yup.string(),
    descriptionOfWork: Yup.string(),
    escrowService: Yup.boolean(),
    contractorInsurance: Yup.string().required(
      "Contractor insurance is required"
    ),
    workersCompensationInsurance: Yup.string().required(
      "Workers' compensation insurance is required"
    ),
    documentName: Yup.string(),
  });

  const getContractDate = (value: any) => {
    if (!value) {
      return null;
    }
    const parsedDate = value instanceof Date ? value : new Date(value);
    return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
  };

  const validation = useFormik({
    initialValues: {
      projectId: project?.p_id || "",
      homeownerName: project?.home_owner
        ? `${project.home_owner.user_first_name} ${project.home_owner.user_last_name}`
        : "",
      additionalHomeownerName:
        project?.contract?.pc_additional_home_owner_name || "",
      contractorName: project?.contractor
        ? `${project.contractor.user_first_name} ${project.contractor.user_last_name}`
        : "",
      projectAddress: project?.p_street_address || "",
      city: project?.p_city || "",
      state: project?.p_state || "",
      zip: project?.p_zip || "",
      startDate: getContractDate(project?.contract?.pc_start_date),
      substantialCompletionDate: getContractDate(project?.contract?.pc_substantial_completion_date),
      endDate: getContractDate(project?.contract?.pc_completion_date),
      projectCostModel: project?.contract?.pc_project_cost_model || "",
      insuranceProviderName:
        project?.contract?.pc_contractor_insurance_provider_name || "",
      totalSalesPrice: project?.p_cost || "",
      allowances: project?.contract?.pc_total_allowance || "",
      descriptionOfWork: project?.contract?.pc_work_description || loganProjectScope,
      escrowService: project?.p_escrow === "1",
      authorizedRepresentative:
        project?.contract?.pc_homeowner_authorized_representative || "",
      contractorAuthorizedRepresentative:
        project?.contract?.pc_contractor_authorized_representative || "",
      contractorInsurance:
        project?.contract?.pc_contractor_insurance_option || "",
      workersCompensationInsurance:
        project?.contract?.pc_worker_compensation_insurance_option || "",
      workersCompensationInsuranceLimit:
        project?.contract?.pc_worker_compensation_insurance_limit || "",
      extraData: extraData,
      homeownerId: project?.p_home_owner_id || "",
      documentName: project?.p_name,
      scopeUrl:project?.contract?.pc_scope_url || "",
    },
    // validationSchema: validationSchema,
    onSubmit: async (values) => {

      // ---------- DATE VALIDATIONS ----------
      const today = new Date();
      today.setHours(0, 0, 0, 0);
    
      if (!values.startDate) {
        date1Ref.current?.focus();
        toast.warning("Start date is required");
        return;
      }
    
      if (new Date(values.startDate) < today) {
        date1Ref.current?.focus();

        toast.warning("Start date cannot be in the past");
        return;
      }
    
      if (!values.substantialCompletionDate) {
        date2Ref.current?.focus();

        toast.warning("Substantial completion date is required");
        return;
      }
    
      if (
        new Date(values.substantialCompletionDate) <
        new Date(values.startDate)
      ) {
        date2Ref.current?.focus();

        toast.warning(
          "Substantial completion date cannot be before start date"
        );
        return;
      }
    
      if (!values.endDate) {
        date3Ref.current?.focus();

        toast.warning("End date is required");
        return;
      }
    
      if (new Date(values.endDate) < new Date(values.startDate)) {
        toast.warning("End date cannot be before start date");
        date3Ref.current?.focus();

        return;
      }
    
      if (
        new Date(values.endDate) <
        new Date(values.substantialCompletionDate)
      ) {
        toast.warning(
          "End date cannot be before substantial completion date"
        );
        date3Ref.current?.focus();

        return;
      }
    
      // ---------- OTHER REQUIRED FIELDS ----------
      if (!values.projectCostModel) {
        toast.warning("Project cost model is required");
        projectCostRef.current?.focus();

        return;
      }
    
      if (!values.contractorInsurance) {
        contrctrInsuranceRef.current?.focus();

        toast.warning("Contractor insurance is required");
        return;
      }
    
      if (!values.workersCompensationInsurance) {
        toast.warning("Workers' compensation insurance is required");
        return;
      }
    
      // ---------- STATE & ACK ----------
      if (!selectedState) {
        toast.warning("Select State to continue");
        stateRef.current?.focus();
        return;
      }

      if (selectedState === "OH") {
        const totalSalesPrice = Number(String(values.totalSalesPrice || "0").replace(/[^0-9.-]/g, ""));
        const liabilityCoverage = Number(String(ohioData.generalLiabilityCoverageAmount || "0").replace(/[^0-9.-]/g, ""));
        const hcssaApplies = totalSalesPrice >= 25000 && liabilityCoverage >= 250000;
        const requiredOhioFields: Array<[string, string]> = [
          ["ocilbTradeLicense", "Enter the OCILB specialty-trade license number or N/A"],
          ["localMunicipalLicense", "Enter the local municipal license/registration number or N/A"],
          ["localJurisdiction", "Enter the property city, village, or township"],
          ["localLicenseType", "Enter the local license/registration type or None"],
          ["localBuildingDepartment", "Enter the local building department name and phone"],
          ["localPermitsRequired", "Enter the local permits required or None"],
          ["localInsuranceBondMinimums", "Enter local insurance/bond minimums or None"],
          ["localOrdinanceExpansion", "Enter the local consumer-right ordinance result or None found"],
        ];
        const missingOhioField = requiredOhioFields.find(([field]) => !String(ohioData[field] || "").trim());

        if (missingOhioField) {
          toast.warning(missingOhioField[1]);
          return;
        }

        if (!Number.isFinite(liabilityCoverage) || liabilityCoverage < 0) {
          toast.warning("Enter a valid commercial general liability coverage amount");
          return;
        }

        if (totalSalesPrice >= 25000 && !/^\d{9}$/.test(federalTaxId)) {
          toast.warning("Enter the 9-digit Federal Tax ID/EIN for this $25,000+ Ohio contract");
          federalTaxIdRef.current?.focus();
          return;
        }

        if (hcssaApplies && !ohioData.excessCostEstimateType) {
          toast.warning("Select the HCSSA excess-cost estimate preference");
          return;
        }

        if (!ohioData.homeSolicitationSale) {
          toast.warning("Select whether this is a Home Solicitation Sale");
          return;
        }

        if (!ohioData.transactionDate) {
          toast.warning("Enter the transaction/signing date");
          return;
        }
      }
    
      if (!ack) {
        setMissingField("ack");
        agreeRef.current?.focus();
        return;
      }
    
      // ---------- API CALL ----------
      setLoading(true);
      try {
        await dispatch(
          createHicContract({
            ...values,
            scopeUrl: scopeUrl,
            state: selectedState,
            federalTaxId,
            paymentSchedule: ohioData.paymentSchedule || "",
            previousCorporation: ohioData.previousCorporation || "",
            extraData: selectedState === "OH" ? { ...extraData, ohio: ohioData } : extraData,
            acknowledgment: ack,
            documentName: values.documentName
              ? `${values.documentName.replace("+", "_")}_${project.p_id}`
              : `${project.p_name.replace("+", "_")}_${project.p_id}`,
          })
        );
    
        if (project !== "") {
          dispatch(getSingleProjectById(project.p_id));
        }
    
        closeModal("created");
        clearLoganProjectScope(project.p_id);
        afterCreate?.();
    
        setNotification({
          status: true,
          message: "Contract Created Successfully",
          variant: "success",
        });
      } catch (error) {
        console.error("Error creating contract:", error);
      } finally {
        setLoading(false);
      }
    },
    
  });

  const buildContractPayload = (saveAsDraft = false) => ({
    ...validation.values,
    scopeUrl,
    state: selectedState,
    federalTaxId,
    paymentSchedule: ohioData.paymentSchedule || "",
    previousCorporation: ohioData.previousCorporation || "",
    extraData: selectedState === "OH" ? { ...extraData, ohio: ohioData } : extraData,
    acknowledgment: ack,
    saveAsDraft,
    documentName: validation.values.documentName
      ? `${validation.values.documentName.replace("+", "_")}_${project.p_id}`
      : `${project.p_name.replace("+", "_")}_${project.p_id}`,
  });

  const handleSaveDraft = async () => {
    if (!project?.p_id) {
      toast.warning("Create the project before saving the contract draft.");
      return;
    }

    setDraftLoading(true);
    try {
      await dispatch(createHicContract(buildContractPayload(true)));
      await dispatch(getSingleProjectById(project.p_id));
      clearLoganProjectScope(project.p_id);
      toast.success("Contract draft saved.");
      closeModal("draft");
    } catch (error) {
      console.error("Error saving contract draft:", error);
      toast.error("Unable to save the contract draft.");
    } finally {
      setDraftLoading(false);
    }
  };
  const [value, setValue] = useState(validation.values.descriptionOfWork || "");
  // const [value, setValue] = useState(html);
  const {t} = useTranslation()

  useEffect(() => {
    validation.setFieldValue("extraData", extraData);
  }, [extraData]);
  const [ack, setAck] = useState("");

  useEffect(() => {
    if (!assistantSnapshot) return;
    const fieldValues: Record<string, any> = {
      additionalHomeownerName: assistantSnapshot.additionalHomeownerName,
      startDate: assistantSnapshot.startDate ? getContractDate(assistantSnapshot.startDate) : undefined,
      substantialCompletionDate: assistantSnapshot.substantialCompletionDate ? getContractDate(assistantSnapshot.substantialCompletionDate) : undefined,
      endDate: assistantSnapshot.endDate ? getContractDate(assistantSnapshot.endDate) : undefined,
      projectCostModel: assistantSnapshot.projectCostModel,
      allowances: assistantSnapshot.allowances,
      descriptionOfWork: assistantSnapshot.descriptionOfWork,
      contractorAuthorizedRepresentative: assistantSnapshot.contractorAuthorizedRepresentative,
      authorizedRepresentative: assistantSnapshot.homeownerAuthorizedRepresentative,
      contractorInsurance: assistantSnapshot.contractorInsurance,
      insuranceProviderName: assistantSnapshot.insuranceProviderName,
      workersCompensationInsurance: assistantSnapshot.workersCompensationInsurance,
      workersCompensationInsuranceLimit: assistantSnapshot.workersCompensationInsuranceLimit,
      documentName: assistantSnapshot.documentName,
    };
    let hasInboundChange = false;
    Object.entries(fieldValues).forEach(([field, nextValue]) => {
      const hasValue = nextValue !== undefined && nextValue !== null && String(nextValue) !== "";
      if (hasValue && String(validation.values[field as keyof typeof validation.values] ?? "") !== String(nextValue)) {
        hasInboundChange = true;
        validation.setFieldValue(field, nextValue, false);
      }
    });
    if (assistantSnapshot.governingState && assistantSnapshot.governingState !== selectedState) {
      hasInboundChange = true;
      setSelectedState(assistantSnapshot.governingState);
    }
    if (hasInboundChange) {
      applyingAssistantSnapshotRef.current = true;
      if (assistantSyncFrameRef.current !== null) window.cancelAnimationFrame(assistantSyncFrameRef.current);
      assistantSyncFrameRef.current = window.requestAnimationFrame(() => {
        applyingAssistantSnapshotRef.current = false;
        assistantSyncFrameRef.current = null;
      });
    }
  }, [assistantSnapshot]);

  useEffect(() => {
    if (applyingAssistantSnapshotRef.current) return;
    onAssistantSnapshotChange?.({
      governingState: selectedState,
      additionalHomeownerName: validation.values.additionalHomeownerName || "",
      startDate: toDateValue(validation.values.startDate),
      substantialCompletionDate: toDateValue(validation.values.substantialCompletionDate),
      endDate: toDateValue(validation.values.endDate),
      projectCostModel: validation.values.projectCostModel || "",
      allowances: validation.values.allowances || "",
      descriptionOfWork: validation.values.descriptionOfWork || "",
      contractorAuthorizedRepresentative: validation.values.contractorAuthorizedRepresentative || "",
      homeownerAuthorizedRepresentative: validation.values.authorizedRepresentative || "",
      contractorInsurance: validation.values.contractorInsurance || "",
      insuranceProviderName: validation.values.insuranceProviderName || "",
      workersCompensationInsurance: validation.values.workersCompensationInsurance || "",
      workersCompensationInsuranceLimit: validation.values.workersCompensationInsuranceLimit || "",
      documentName: validation.values.documentName || "",
    });
  }, [
    selectedState,
    validation.values.additionalHomeownerName,
    validation.values.startDate,
    validation.values.substantialCompletionDate,
    validation.values.endDate,
    validation.values.projectCostModel,
    validation.values.allowances,
    validation.values.descriptionOfWork,
    validation.values.contractorAuthorizedRepresentative,
    validation.values.authorizedRepresentative,
    validation.values.contractorInsurance,
    validation.values.insuranceProviderName,
    validation.values.workersCompensationInsurance,
    validation.values.workersCompensationInsuranceLimit,
    validation.values.documentName,
    onAssistantSnapshotChange,
  ]);

  useEffect(() => () => {
    if (assistantSyncFrameRef.current !== null) window.cancelAnimationFrame(assistantSyncFrameRef.current);
  }, []);
  const renderState = () => {
    switch (selectedState) {
      case "FL": {
        return <Florida onExtraData={handleExtraData} />;
      }
      case "MA": {
        return <Massuchusetts onExtraData={handleExtraData} />;
      }
      case "DE": {
        return <Delaware onExtraData={handleExtraData} />;
      }
      case "OH": {
        return <OhioContractFields value={ohioData} onChange={setOhioData} />;
      }
    }
  };
  const [isUploading, setIsUploading] = useState<boolean>(false);
  function validateFileName(fileName: string) {
    const invalidChars = /[!@#\$%\^&\*\(\)\+=\{\}\[\]\|\\;:'",<>\/?]/;
    return !invalidChars.test(fileName); // Returns true if valid, false if invalid
  }
  const agreeRef = useRef<HTMLInputElement | null>(null);
  const stateRef = useRef<any>(null);
  const date1Ref = useRef<any>(null);
  const date2Ref = useRef<any>(null);
  const date3Ref = useRef<any>(null);
  const projectCostRef = useRef<any>(null);
  const contrctrInsuranceRef = useRef<any>(null);
  const federalTaxIdRef = useRef<HTMLInputElement | null>(null);
  const sectionRefs = {
    contractType: useRef<HTMLDivElement | null>(null),
    parties: useRef<HTMLDivElement | null>(null),
    dates: useRef<HTMLDivElement | null>(null),
    costScope: useRef<HTMLDivElement | null>(null),
    insurance: useRef<HTMLDivElement | null>(null),
    document: useRef<HTMLDivElement | null>(null),
  };
  const focusSection = (section: keyof typeof sectionRefs, focusTarget?: any) => {
    sectionRefs[section].current?.scrollIntoView({ behavior: "smooth", block: "start" });
    window.setTimeout(() => {
      focusTarget?.current?.focus?.();
    }, 250);
  };
  const handleScopeImageChange = async (file: any) => {
    if (!validateFileName(file.name)) {
      alert("Invalid file name");
      return;
    }
  
    try {
      setShowStreamModal(true);
      setCurrentStage("uploading");
      setExtractedHTML("")
      const resp: any = await dispatch(sendDocToS3("contractScope", file));
      setScopeUrl(resp);
  
      setCurrentStage("routing");
  
      const response = await fetch(`${apiUrl}/misc/document-ai-v5`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ url: resp }),
      });
  
      if (!response.body) throw new Error("No stream");
  
      const reader = response.body.getReader();
      const decoder = new TextDecoder("utf-8");
  
      let buffer = "";
      let finalHtml = "";
  
      while (true) {
        const { value, done } = await reader.read();
        if (done) break;
  
        buffer += decoder.decode(value, { stream: true });
        const parts = buffer.split("\n\n");
        buffer = parts.pop() || "";
  
        for (const part of parts) {
          if (!part.startsWith("data:")) continue;
          const payload = part.replace("data:", "").trim();
  
          if (payload === "[DONE]") {
            setCurrentStage("complete");
            setValue(finalHtml.replace("html",""));
            validation.setFieldValue("descriptionOfWork", finalHtml.replace("html",""));
            return;
          }
  
          const msg = JSON.parse(payload);
  
          // routing done
          if (msg.status === "routed") {
            setCurrentStage("processing");
            continue;
          }
  
          // engine started
          if (msg.engine) {
            setCurrentStage("processing");
            continue;
          }
  
          // streaming content
          if (msg.chunk) {
            setCurrentStage("streaming");
            finalHtml += msg.chunk;
            setExtractedHTML(finalHtml.replace("html","")); // 👈 live preview
          }
  
          if (msg.status === "done") {
            setCurrentStage("complete");
          }
        }
      }
    } catch (e) {
      console.error(e);
      setShowStreamModal(false);
    } finally{
      setShowStreamModal(false);
      
    }
  };
  
  const loadingTips = [
    "Fetching contract template from database...",
    "Validating all contract clauses and terms...",
    "Merging your documents with contract template...",
    "Processing attachments and related files...",
    "Applying legal formatting and standards...",
    "Generating secure PDF document...",
    "Almost ready! Finalizing your contract..."
  ];

  useEffect(() => {
    if (loading) {
      // Reset states when modal opens
      setPdfUrl(null);
      setHasReviewed(false);
      setCurrentTip(0);
   

      // Rotate tips every 800ms
      const tipInterval = setInterval(() => {
        
        setCurrentTip((prev) => (prev + 1) % loadingTips.length);
      }, 800);

      // Complete loading after duration
  

      return () => {
        clearInterval(tipInterval);
      };
    }
  }, [loading]);
  
useEffect(()=>{
if(project?.contract?.pc_scope_url){
  setScopeUrl(project?.contract?.pc_scope_url)
}
if(project?.contract?.pc_acknowledgment){
  setAck(project?.contract?.pc_acknowledgment)
}
},[project?.contract])
const sectionCardClass = "hic-form-section";
const setupItems = [
  { label: "Contract Type", ready: Boolean(selectedState), icon: FileText, section: "contractType", focusRef: stateRef },
  { label: "Parties", ready: Boolean(validation.values.homeownerName && validation.values.contractorName), icon: UsersRound, section: "parties" },
  { label: "Dates", ready: Boolean(validation.values.startDate && validation.values.substantialCompletionDate && validation.values.endDate), icon: CalendarDays, section: "dates", focusRef: date1Ref },
  { label: "Cost & Scope", ready: Boolean(validation.values.projectCostModel), icon: DollarSign, section: "costScope", focusRef: projectCostRef },
  { label: "Insurance", ready: Boolean(validation.values.contractorInsurance && validation.values.workersCompensationInsurance), icon: ShieldCheck, section: "insurance", focusRef: contrctrInsuranceRef },
  { label: "Document", ready: Boolean(validation.values.documentName || project?.p_name), icon: FileText, section: "document" },
];
const completedSetupCount = setupItems.filter((item) => item.ready).length;
const requiredRemaining = [
  selectedState,
  validation.values.startDate,
  validation.values.substantialCompletionDate,
  validation.values.endDate,
  validation.values.projectCostModel,
  validation.values.contractorInsurance,
  validation.values.workersCompensationInsurance,
  ack,
].filter((item) => !item).length;
const projectCostOptions = [
  {
    label: "Total Cost of the Project",
    description: "Total cost of the project excluding agreed allowances.",
    value: "Total Cost of the Project",
  },
  {
    label: "Cost of Work + Contractor Fee",
    description: "Cost of the work plus the contractor's fee.",
    value: "Cost of the Work plus the Contractor’s Fee",
  },
  {
    label: "Time and Materials",
    description: "Work is billed based on time and materials.",
    value: "Time and Materials",
  },
];
const contractorInsuranceOptions = [
  { label: "Carries commercial general liability insurance", value: "yes" },
  { label: "Does not carry commercial general liability insurance", value: "no" },
  { label: "Self-insured", value: "selfInsured" },
];
const workersCompensationOptions = [
  {
    label: "No employees / exempt from Workers' Compensation",
    value: "noEmployees",
  },
  {
    label: "Carries Workers' Compensation Insurance",
    value: "hasInsurance",
  },
];
  return (
    <React.Fragment>
      {notification && notification.status && (
        <div
          style={{
            position: "absolute",
            top: "5%",
            right: "24px",
            zIndex: 99999,
          }}
        >
          <Alert variant={notification.variant} onClick={handleAlertClick}>
            {notification.message}
          </Alert>
        </div>
      )}

        <div className="tailwind-prefix relative hic-contract-creator">
          {loading ? (
            <div className="fixed inset-0 z-[1050] flex items-center justify-center bg-black/45 px-4 backdrop-blur-sm">
              <div className="w-full max-w-md rounded-xl border border-blue-100 bg-white px-5 py-5 text-center text-sm shadow-2xl">
                <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-blue-50 text-blue-700">
                  <Loader2 className="h-6 w-6 animate-spin" />
                </div>
                <div className="font-medium text-gray-900">{t("Creating contract document...")}</div>
                <div className="mt-1 text-blue-700">{loadingTips[currentTip]}</div>
              </div>
            </div>
          ) : null}
          <Container fluid className="hic-contract-container">
            <Row className="hic-contract-overview-row">
              <Col>
                <div className="hic-contract-overview">
                  <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3">
                    <div>
                      <div className="inline-flex items-center gap-2 rounded-md bg-blue-50 px-2.5 py-1 text-xs font-medium text-blue-700">
                        <FileText className="h-3.5 w-3.5" />
                        {t("Home Improvement Contract")}
                      </div>
                      <div className="mt-2 text-base font-semibold text-gray-900">{t("Contract setup")}</div>
                      <div className="mt-1 max-w-3xl text-sm text-gray-600">
                        {t("Use the sections below to review required details before generating the document.")}
                      </div>
                    </div>
                    <div className="hic-setup-progress" aria-label={`${completedSetupCount} ${t("of")} ${setupItems.length} ${t("setup sections complete")}`}>
                      <div>
                        <div className="text-xs font-medium text-gray-500">{t("Setup progress")}</div>
                        <div className="mt-0.5 text-lg font-semibold text-gray-900">{completedSetupCount}/{setupItems.length}</div>
                      </div>
                      <div className="hic-setup-progress__track" aria-hidden="true">
                        <span style={{ width: `${(completedSetupCount / setupItems.length) * 100}%` }} />
                      </div>
                    </div>
                  </div>
                  <div className="hic-section-jump-list">
                    {setupItems.map((item) => {
                      const Icon = item.icon;
                      return (
                        <button
                          key={item.label}
                          type="button"
                          onClick={() => focusSection(item.section as keyof typeof sectionRefs, item.focusRef)}
                          className={`hic-section-jump ${item.ready ? "is-complete" : ""}`}
                        >
                          {item.ready ? <CheckCircle2 className="h-4 w-4 flex-none" /> : <Icon className="h-4 w-4 flex-none" />}
                          <span>{t(item.label)}</span>
                        </button>
                      );
                    })}
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
          <div>
            <Container fluid className="hic-contract-container hic-contract-form-container">
              <Row ref={sectionRefs.contractType} className={sectionCardClass}>
                <Col>
                  <div className="mb-3 flex items-start gap-3">
                    <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-blue-50 text-blue-700">
                      <FileText className="h-5 w-5" />
                    </div>
                    <div>
                      <h5 className="mb-1">{t("Contract Type")}</h5>
                      <p className="mb-0 text-sm text-gray-600">{t("Select the governing law state for this homeowner contract.")}</p>
                    </div>
                  </div>
                  <Col lg={4}>
                    <Form.Label className="font-medium">{t("Governing Law State")} *</Form.Label>
                    <Form.Select
                      className="fs-6"
                      ref={stateRef}
                      value={selectedState}
                      onChange={(e) => setSelectedState(e.target.value)}
                    >
             
                      <option     value="">Select State</option>
                      <option
                        value="CT"
                      
                      >
                        Connecticut
                      </option>
                      <option value="FL">
                        Florida
                      </option>
                      <option value="MA">
                        Massachusetts
                      </option>
                      <option value="DE">
                        Delaware
                      </option>
                      <option value="OH">Ohio</option>
                    </Form.Select>
                  </Col>
                  {selectedState === "OH" && (
                    <Col lg={4} className="mt-3">
                      <Form.Label className="font-medium">{t("Federal Tax ID / EIN")} *</Form.Label>
                      <Form.Control
                        ref={federalTaxIdRef}
                        type="password"
                        inputMode="numeric"
                        autoComplete="off"
                        maxLength={9}
                        value={federalTaxId}
                        placeholder={t("Enter 9-digit EIN")}
                        onChange={(event) => setFederalTaxId(event.target.value.replace(/\D/g, "").slice(0, 9))}
                        isInvalid={Boolean(federalTaxId && !/^\d{9}$/.test(federalTaxId))}
                      />
                      <Form.Text className="text-muted">
                        {company?.cc_federal_tax_id
                          ? t("Loaded from company profile and saved with this contract.")
                          : t("This will also be saved to company profile so it is requested only once.")}
                      </Form.Text>
                    </Col>
                  )}
                </Col>
              </Row>

              <Row ref={sectionRefs.parties} className={sectionCardClass}>
                <Col>
                  <div className="mb-3 flex items-start gap-3">
                    <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-green-50 text-green-700">
                      <UsersRound className="h-5 w-5" />
                    </div>
                    <div>
                      <h5 className="mb-1">{t("Homeowner Details")}</h5>
                      <p className="mb-0 text-sm text-gray-600">{t("The primary homeowner is prefilled. Add an additional homeowner only when needed.")}</p>
                    </div>
                  </div>
                  <Col lg={7}>
                    <div className="mb-3 rounded-lg border border-gray-200 bg-gray-50 p-3">
                      <div className="text-xs font-medium uppercase text-gray-500">{t("Primary Homeowner")}</div>
                      <div className="mt-1 text-sm font-semibold text-gray-900">{validation.values.homeownerName || "-"}</div>
                      <div className="mt-1 text-xs text-gray-500">{t("Locked from Project Info")}</div>
                    </div>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        {t("Additional Homeowner Name")}
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id="tooltip-top">
                              {" "}
                              Please enter additional homeowner name{" "}
                            </Tooltip>
                          }
                        >
                          <Button className="infoButton">?</Button>
                        </OverlayTrigger>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="additionalHomeownerName"
                        placeholder={t("Optional")}
                        value={validation.values.additionalHomeownerName || ""}
                        onChange={validation.handleChange}
                      />
                      <Form.Control.Feedback type="invalid">
                        {validation.errors.additionalHomeownerName &&
                          !!validation.errors.additionalHomeownerName}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Col>
              </Row>

              <Row ref={sectionRefs.dates} className={sectionCardClass}>
                <Col>
                  <div className="mb-3 flex items-start gap-3">
                    <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-green-50 text-green-700">
                      <UsersRound className="h-5 w-5" />
                    </div>
                    <div>
                      <h5 className="mb-1">{t("Contractor Details")}</h5>
                      <p className="mb-0 text-sm text-gray-600">{t("Contractor information is prefilled from the project profile.")}</p>
                    </div>
                  </div>
                  <Col lg={7}>
                    <div className="rounded-lg border border-gray-200 bg-gray-50 p-3">
                      <div className="text-xs font-medium uppercase text-gray-500">{t("Contractor")}</div>
                      <div className="mt-1 text-sm font-semibold text-gray-900">{validation.values.contractorName || "-"}</div>
                      <div className="mt-1 text-xs text-gray-500">{t("Locked from Project Info")}</div>
                    </div>
                  </Col>
                </Col>
              </Row>

              <Row ref={sectionRefs.costScope} className={sectionCardClass}>
                <Col>
                  <div className="mb-3 flex items-start gap-3">
                    <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-gray-100 text-gray-700">
                      <MapPin className="h-5 w-5" />
                    </div>
                    <div>
                      <h5 className="mb-1">{t("Project Address")}</h5>
                      <p className="mb-0 text-sm text-gray-600">{t("Address details are locked from the project information step.")}</p>
                    </div>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
                    <div className="md:col-span-4 rounded-lg border border-gray-200 bg-gray-50 p-3">
                      <div className="text-xs font-medium uppercase text-gray-500">{t("Street Address")}</div>
                      <div className="mt-1 text-sm font-semibold text-gray-900">{validation.values.projectAddress || "-"}</div>
                    </div>
                    <div className="rounded-lg border border-gray-200 bg-gray-50 p-3">
                      <div className="text-xs font-medium uppercase text-gray-500">{t("City")}</div>
                      <div className="mt-1 text-sm font-semibold text-gray-900">{validation.values.city || "-"}</div>
                    </div>
                    <div className="rounded-lg border border-gray-200 bg-gray-50 p-3">
                      <div className="text-xs font-medium uppercase text-gray-500">{t("State")}</div>
                      <div className="mt-1 text-sm font-semibold text-gray-900">{validation.values.state || "-"}</div>
                    </div>
                    <div className="rounded-lg border border-gray-200 bg-gray-50 p-3">
                      <div className="text-xs font-medium uppercase text-gray-500">{t("Zip")}</div>
                      <div className="mt-1 text-sm font-semibold text-gray-900">{validation.values.zip || "-"}</div>
                    </div>
                    <div className="rounded-lg border border-gray-200 bg-gray-50 p-3">
                      <div className="text-xs font-medium uppercase text-gray-500">{t("Source")}</div>
                      <div className="mt-1 text-sm font-semibold text-gray-900">{t("Project Info")}</div>
                    </div>
                  </div>
                </Col>
              </Row>

              <Row className={sectionCardClass}>
                <Col>
                  <div className="mb-3 flex items-start gap-3">
                    <div className="hic-section-icon">
                      <CalendarDays className="h-5 w-5" />
                    </div>
                    <div>
                      <h5 className="mb-1">{t("Project Dates")}</h5>
                      <p className="mb-0 text-sm text-gray-600">{t("Set the expected schedule used in the contract document.")}</p>
                    </div>
                  </div>
                  <Row className="hic-date-grid">
                    <Col md={4}>
                      <Form.Group className="hic-date-field">
                      <Form.Label ref={date1Ref} className="w-100">
                        Start date <span className="hic-required-mark" aria-hidden="true">*</span>{" "}
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id="start-date-tooltip">
                              {" "}
                              Please enter start date of your project{" "}
                            </Tooltip>
                          }
                        >
                          <Button className="infoButton">?</Button>
                        </OverlayTrigger>
                      </Form.Label>
                      <DatePicker
                        className={`form-control w-100 ${validation.touched.startDate && validation.errors.startDate ? "is-invalid" : ""}`}
                        wrapperClassName="hic-date-picker-input"
                        calendarClassName="hic-date-picker"
                        popperClassName="hic-date-picker-popper"
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        selected={validation.values.startDate}
                        onChange={(date) =>
                          validation.setFieldValue("startDate", date)
                        }
                        minDate={new Date(new Date().setDate(new Date().getDate() + 3))}
                        onBlur={() => validation.setFieldTouched("startDate")}
                        dateFormat="MM/dd/yyyy"
                      />
                      {validation.touched.startDate &&
                      validation.errors.startDate ? (
                        <div className="invalid-feedback d-block">
                          {validation.errors.startDate}
                        </div>
                      ) : null}
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group className="hic-date-field">
                      <Form.Label ref={date2Ref}  className="w-100">
                        Substantial completion date <span className="hic-required-mark" aria-hidden="true">*</span>
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id="substantial-completion-date-tooltip">
                              {" "}
                              When construction is sufficiently complete{" "}
                            </Tooltip>
                          }
                        >
                          <Button className="infoButton">?</Button>
                        </OverlayTrigger>
                      </Form.Label>
                      <DatePicker
                        className={`form-control w-100 ${validation.touched.substantialCompletionDate && validation.errors.substantialCompletionDate ? "is-invalid" : ""}`}
                        wrapperClassName="hic-date-picker-input"
                        calendarClassName="hic-date-picker"
                        popperClassName="hic-date-picker-popper"
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        selected={validation.values.substantialCompletionDate}
                        onChange={(date) =>
                          validation.setFieldValue(
                            "substantialCompletionDate",
                            date
                          )
                        }
                        minDate={new Date(new Date().setDate(new Date().getDate() + 3))}
                        onBlur={() =>
                          validation.setFieldTouched(
                            "substantialCompletionDate"
                          )
                        }
                        dateFormat="MM/dd/yyyy"
                      />
                      {validation.touched.substantialCompletionDate &&
                      validation.errors.substantialCompletionDate ? (
                        <div className="invalid-feedback d-block">
                          {validation.errors.substantialCompletionDate}
                        </div>
                      ) : null}
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group className="hic-date-field">
                      <Form.Label ref={date3Ref}  className="w-100">
                        End date <span className="hic-required-mark" aria-hidden="true">*</span>
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id="end-date-tooltip">
                              {" "}
                              End Date of Construction{" "}
                            </Tooltip>
                          }
                        >
                          <Button className="infoButton">?</Button>
                        </OverlayTrigger>
                      </Form.Label>
                      <DatePicker
                        className={`form-control w-100 ${validation.touched.endDate && validation.errors.endDate ? "is-invalid" : ""}`}
                        wrapperClassName="hic-date-picker-input"
                        calendarClassName="hic-date-picker"
                        popperClassName="hic-date-picker-popper"
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        selected={validation.values.endDate}
                        minDate={new Date(new Date().setDate(new Date().getDate() + 3))}
                        onChange={(date) =>
                          validation.setFieldValue("endDate", date)
                        }
                        onBlur={() => validation.setFieldTouched("endDate")}
                        dateFormat="MM/dd/yyyy"
                      />
                      {validation.touched.endDate &&
                      validation.errors.endDate ? (
                        <div className="invalid-feedback d-block">
                          {validation.errors.endDate}
                        </div>
                      ) : null}
                      </Form.Group>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row className={sectionCardClass}>
                <Col>
                  <div className="mb-3 flex items-start gap-3">
                    <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-emerald-50 text-emerald-700">
                      <DollarSign className="h-5 w-5" />
                    </div>
                    <div>
                      <h5 className="mb-1">
                        {t("Project Cost Model")} *
                    <OverlayTrigger
                      placement="top"
                    
                      overlay={
                    <Tooltip  id="tooltip-top">
                          {" "}
                          Please select Project cost modal{" "}
                        </Tooltip>
                      }
                    >
                      <Button className="infoButton">?</Button>
                    </OverlayTrigger>
                      </h5>
                      <p className="mb-0 text-sm text-gray-600">{t("Choose the pricing model that should appear in the contract.")}</p>
                    </div>
                  </div>
                  <Col>
                  <div className="hic-choice-grid hic-choice-grid--three" role="radiogroup" aria-label={t("Project Cost Model")} aria-required="true">
                    {projectCostOptions.map((option, index) => {
                      const selected = validation.values.projectCostModel === option.value;
                      return (
                          <label
                            key={option.value}
                            className={`hic-choice-card hic-choice-card--stacked ${selected ? "is-selected" : ""}`}
                          >
                            <input
                              ref={index === 0 ? projectCostRef : undefined}
                              type="radio"
                              name="projectCostModel"
                              value={option.value}
                              checked={selected}
                              onChange={() => validation.setFieldValue("projectCostModel", option.value)}
                              className="sr-only"
                            />
                            <div className="flex items-start justify-between gap-3">
                              <div className="text-sm font-semibold">{t(option.label)}</div>
                              <span className="hic-choice-indicator" aria-hidden="true">
                                {selected ? <CheckCircle2 className="h-4 w-4" /> : null}
                              </span>
                            </div>
                            <div className="mt-1 text-sm text-gray-600">{t(option.description)}</div>
                          </label>
                        );
                      })}
                    </div>
                    <Form.Control.Feedback type="invalid">
                      {validation.errors.projectCostModel &&
                        !!validation.errors.projectCostModel}
                    </Form.Control.Feedback>
                  </Col>
                </Col>
              </Row>

              <Row className={sectionCardClass}>
                <Col>
                  <div className="mb-3 flex items-start gap-3">
                    <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-emerald-50 text-emerald-700">
                      <DollarSign className="h-5 w-5" />
                    </div>
                    <div>
                      <h5 className="mb-1">{t("Total Sales Price")} *</h5>
                      <p className="mb-0 text-sm text-gray-600">{t("This amount is pulled from the project cost and shown as read-only.")}</p>
                    </div>
                  </div>
                  <Col lg={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>Total Sales Price *</Form.Label>
                      <Form.Control
                        type="text"
                        id="totalSalesPrice"
                        name="totalSalesPrice"
                        value={`$ ${ validation.values.totalSalesPrice &&Number(  validation.values.totalSalesPrice)?.toLocaleString('en-US', { minimumFractionDigits: 2 })} `|| ""}
                        disabled
                        onChange={validation.handleChange}
                      />
                    </Form.Group>
                  </Col>
                </Col>
              </Row>

              <Row className={sectionCardClass}>
                <Col md={10}>
                  <h5>{t("Allowances")}</h5>
                  <Form.Group className="mb-3">
                    <Form.Label>Total allowances</Form.Label>
                    <Form.Control
                      type="text"
                      id="allowances"
                      name="allowances"
                      value={validation.values.allowances || ""}
                      onChange={validation.handleChange}
                    />
                    <Form.Control.Feedback type="invalid">
                      {validation.errors.allowances &&
                        !!validation.errors.allowances}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              <Row className={sectionCardClass}>
                <Col md={10}>
                  <div className="mb-3 flex items-start gap-3">
                    <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-blue-50 text-blue-700">
                      <UploadCloud className="h-5 w-5" />
                    </div>
                    <div>
                      <h5 className="mb-1">{t("Scope of Work")}</h5>
                      <p className="mb-0 text-sm text-gray-600">{t("Describe the work and upload a supporting PDF if the scope lives in a separate document.")}</p>
                    </div>
                  </div>
                  <Form.Group className="mb-3">
                    <Form.Label>Scope of Works (optional)</Form.Label>
                    <div className="max-h-[300px] overflow-auto pr-1 rounded-lg border border-gray-200 bg-white"> 
                    <RichEditorTipTab value={value} onChange={(e:any)=>{
  setValue(e)
  
  validation.setFieldValue("descriptionOfWork",e)
}} />   
                    </div>
           
      
                  {validation.touched.descriptionOfWork && validation.errors.descriptionOfWork && (
  <div className="text-danger">
    Scope of Work required
  </div>
)}

                  </Form.Group>

                  <Dropzone
      onDrop={(acceptedFiles: any) => {
        if (acceptedFiles && acceptedFiles.length > 0) {
          const selectedFile = acceptedFiles[0];
          handleScopeImageChange(selectedFile)

          if (selectedFile.type.startsWith("image/")) {
            setPreview(URL.createObjectURL(selectedFile));
          } else if (selectedFile.type === "application/pdf") {
            setPreview(URL.createObjectURL(selectedFile)); // PDF ke liye bhi object URL banega
          } else {
            setPreview(null);
          }
        }
      }}
      accept={{
        "application/pdf": [".pdf"],
      }}
      maxFiles={1}
    >
      {({ getRootProps, getInputProps }: any) => (
        <div className="tailwind-prefix">
          <div
            className="dropzone course-dropzone border border-1 border-dashed text-center p-4"
            {...getRootProps()}
          >
            <input {...getInputProps()} />
            <div className="dz-message needsclick">
              <div className="mb-3">
                <i className="display-4 text-muted ri-upload-cloud-2-fill" />
              </div>
              <h4>{preview ||scopeUrl ? "Change Document" : "Upload Document"}</h4>
            </div>
          </div>


          {(isUploading || scopeUrl) && (
  <div className="mt-3 relative w-fit">
    <>
      {isUploading ? (
        <div className="flex items-center justify-center w-48 h-48 border rounded-lg bg-gray-50">
          <span className="text-gray-500 text-sm animate-pulse">Uploading...</span>
        </div>
      ) : scopeUrl?.toLowerCase().endsWith(".pdf") ? (
        <iframe
          src={scopeUrl}
          className="w-full h-64 rounded-lg border"
          title="PDF Preview"
        />
      ) : (
        <img
          src={scopeUrl}
          alt="preview"
          className="max-h-48 rounded-lg border"
        />
      )}

      {!isUploading && scopeUrl && (
        <div
          onClick={() => {
            setScopeUrl('');
            setFile(null);
            setPreview(null);
          }}
          className="absolute top-1 right-1 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs hover:bg-red-600 cursor-pointer"
        >
          ✕
        </div>
      )}

    </>
  </div>
)}


        </div>
      )}
    </Dropzone>

    <div className="">
          <div className="text-[16px] pt-4 font-semibold text-gray-900">
            Contractor Acknowledgment of Figures & Liability Waiver
          </div>
        </div>

        {/* Content */}
        <div className=" space-y-4 text-sm text-gray-700 leading-relaxed">
          <div className="font-semibold text-lg text-gray-500">
            Contractor Certification
          </div>

          <p>
            The undersigned Contractor hereby certifies and acknowledges the
            following:
          </p>

          <p>
            The Contractor has fully reviewed all figures, pricing, costs, fees,
            and financial terms submitted to the Homeowner and to any other
            person, firm, or corporation in connection with this project, and
            affirmatively represents that all such figures are accurate,
            complete, and correct to the best of the Contractor’s knowledge and
            belief.
          </p>

          <p>
            The Contractor further acknowledges and agrees that{" "}
            <span className="font-medium">
              The Tradesmen's Collective, TTC, USA
            </span>{" "}
            acts solely as a facilitation and compliance platform and shall not
            be responsible or liable for any inconsistencies, inaccuracies,
            omissions, misstatements, or incorrect information contained in the
            final contract terms, costs, pricing, or fees.
          </p>

          <p>
            All responsibility for the accuracy of such figures remains
            exclusively with the Contractor.
          </p>

          <div style={{
            color:missingField==="ack"?"red":"#111827"
          }} className="pt-3 text-lg font-semibold ">
            Required Acknowledgment
          </div>

          {/* Radio Buttons */}
          <div className="space-y-3">
            <label className="flex gap-3 p-3 border rounded-lg cursor-pointer hover:bg-gray-50">
              <input
                type="radio"
                ref={agreeRef}
                name="ack"
                value="agree"
                checked={ack === "agree"}
                onChange={(e) => {
                  setAck(e.target.value)
                  setMissingField("")
                }}
                className="mt-1"
              />
              <span>
                <b>I AGREE</b> — The Contractor affirms the above certification
                and accepts full responsibility for all submitted figures and
                financial terms.
              </span>
            </label>

            {/* <label className="flex gap-3 p-3 border rounded-lg cursor-pointer hover:bg-gray-50">
              <input
                type="radio"
                name="ack"
                value="disagree"
                checked={ack === "disagree"}
                onChange={(e) => {
                  setAck(e.target.value)
                  setMissingField("")
                }}
                className="mt-1"
              />
              <span>
                <b>I DO NOT AGREE</b> — The Contractor has not verified the
                figures and understands that the contract cannot proceed until
                verification is completed.
              </span>
            </label> */}
          </div>
        </div>


                </Col>
              </Row>


              <Row className={sectionCardClass}>
                <Col>
                  <h5>Escrow Service</h5>
                  <p className="mb-2">Escrow</p>
                  <Form.Check
                    disabled
                    type="switch"
                    id="escrowService"
                    name="escrowService"
                    label="Enable Escrow Service"
                    checked={validation.values.escrowService}
                    onChange={validation.handleChange}
                  />
                  {validation.errors.escrowService &&
                    validation.touched.escrowService && (
                      <div className="text-danger">
                        {validation.errors.escrowService}
                      </div>
                    )}
                </Col>
              </Row>

              <Row className={sectionCardClass}>
                <Col md={5}>
                  <h5>Authorized Representatives</h5>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Contractor Authorized Representative First and Last Name
                    </Form.Label>
                    <Form.Control
                      type="text"
                      id="contractorAuthorizedRepresentative"
                      name="contractorAuthorizedRepresentative"
                      value={
                        validation.values.contractorAuthorizedRepresentative ||
                        ""
                      }
                      onChange={validation.handleChange}
                    />
                    {validation.errors.contractorAuthorizedRepresentative && (
                      <div className="text-danger">
                        {validation.errors.contractorAuthorizedRepresentative &&
                          !!validation.errors
                            .contractorAuthorizedRepresentative}
                      </div>
                    )}
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Homeowner Authorized Representative First and Last Name
                    </Form.Label>
                    <Form.Control
                      type="text"
                      id="authorizedRepresentative"
                      name="authorizedRepresentative"
                      value={validation.values.authorizedRepresentative || ""}
                      onChange={validation.handleChange}
                    />
                    {validation.errors.authorizedRepresentative && (
                      <div className="text-danger">
                        {validation.errors.authorizedRepresentative &&
                          !!validation.errors.authorizedRepresentative}
                      </div>
                    )}
                  </Form.Group>
                </Col>
              </Row>

             
              <Row ref={sectionRefs.insurance} className={sectionCardClass}>
                <Col>
                  <div className="mb-3 flex items-start gap-3">
                    <div className="hic-section-icon">
                      <ShieldCheck className="h-5 w-5" />
                    </div>
                    <div>
                      <h5 id="contractor-insurance-heading" className="mb-1">{t("Contractor Insurance")} <span className="hic-required-mark" aria-hidden="true">*</span></h5>
                      <p className="mb-0 text-sm text-gray-600">{t("Choose the insurance statement that should appear in the contract.")}</p>
                    </div>
                  </div>
                  <div className="hic-choice-grid hic-choice-grid--three" role="radiogroup" aria-labelledby="contractor-insurance-heading" aria-required="true">
                    {contractorInsuranceOptions.map((option) => {
                      const selected = validation.values.contractorInsurance === option.value;
                      return (
                        <label key={option.value} className={`hic-choice-card ${selected ? "is-selected" : ""}`}>
                          <input
                            name="contractorInsurance"
                            type="radio"
                            value={option.value}
                            checked={selected}
                            onChange={() => validation.setFieldValue("contractorInsurance", option.value)}
                            className="sr-only"
                          />
                          <div className="flex items-start justify-between gap-3">
                            <span className="font-medium">{t(option.label)}</span>
                            <span className="hic-choice-indicator" aria-hidden="true">
                              {selected ? <CheckCircle2 className="h-4 w-4" /> : null}
                            </span>
                          </div>
                        </label>
                      );
                    })}
                  </div>
                  {validation.values.contractorInsurance === "yes" && (
                    <Form.Group  className="mb-3">
                      <Form.Label>Insurance Provider Name:</Form.Label>
                      <Form.Control
                        type="text"
                        name="insuranceProviderName"
                        value={validation.values.insuranceProviderName}
                        onChange={validation.handleChange}
                      />
                      {validation.errors.insuranceProviderName &&
                        validation.touched.insuranceProviderName && (
                          <div className="text-danger">
                            {validation.errors.insuranceProviderName &&
                              !!validation.errors.insuranceProviderName}
                          </div>
                        )}
                    </Form.Group>
                  )}
                  {validation.errors.contractorInsurance &&
                    validation.touched.contractorInsurance && (
                      <div className="text-danger">
                        {validation.errors.contractorInsurance &&
                          !!validation.errors.contractorInsurance}
                      </div>
                    )}
                </Col>
              </Row>

              <Row ref={sectionRefs.document} className={sectionCardClass}>
                <Col>
                  <div className="mb-3 flex items-start gap-3">
                    <div className="hic-section-icon">
                      <ShieldCheck className="h-5 w-5" />
                    </div>
                    <div>
                      <h5 id="workers-compensation-heading" className="mb-1">{t("Worker's Compensation Insurance")} <span className="hic-required-mark" aria-hidden="true">*</span></h5>
                      <p className="mb-0 text-sm text-gray-600">{t("Choose the workers' compensation statement for the contract.")}</p>
                    </div>
                  </div>
                  <div className="hic-choice-grid hic-choice-grid--two" role="radiogroup" aria-labelledby="workers-compensation-heading" aria-required="true">
                    {workersCompensationOptions.map((option) => {
                      const selected = validation.values.workersCompensationInsurance === option.value;
                      return (
                        <label key={option.value} className={`hic-choice-card ${selected ? "is-selected" : ""}`}>
                          <input
                            name="workersCompensationInsurance"
                            type="radio"
                            value={option.value}
                            checked={selected}
                            onChange={() => validation.setFieldValue("workersCompensationInsurance", option.value)}
                            className="sr-only"
                          />
                          <div className="flex items-start justify-between gap-3">
                            <span className="font-medium">{t(option.label)}</span>
                            <span className="hic-choice-indicator" aria-hidden="true">
                              {selected ? <CheckCircle2 className="h-4 w-4" /> : null}
                            </span>
                          </div>
                        </label>
                      );
                    })}
                  </div>
                  {validation.values.workersCompensationInsurance ===
                    "hasInsurance" && (
                    <Row>
                      <Col md={4}>
                        <Form.Group className="mb-3">
                          <Form.Label>
                            Worker's Compensation Insurance Limit *
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="workersCompensationInsuranceLimit"
                            value={
                              validation.values
                                .workersCompensationInsuranceLimit
                            }
                            onChange={validation.handleChange}
                          />
                          {validation.errors
                            .workersCompensationInsuranceLimit &&
                            validation.touched
                              .workersCompensationInsuranceLimit && (
                              <div className="text-danger">
                                {validation.errors
                                  .workersCompensationInsuranceLimit &&
                                  !!validation.errors
                                    .workersCompensationInsuranceLimit}
                              </div>
                            )}
                        </Form.Group>
                      </Col>
                    </Row>
                  )}
                  {validation.errors.workersCompensationInsurance &&
                    validation.touched.workersCompensationInsurance && (
                      <div className="text-danger">
                        {validation.errors.workersCompensationInsurance &&
                          !!validation.errors.workersCompensationInsurance}
                      </div>
                    )}
                </Col>
              </Row>

              {renderState()}
              <Row className={sectionCardClass}>
                <Col>
                  <div className="mb-3 flex items-start gap-3">
                    <div className="hic-section-icon">
                      <FileText className="h-5 w-5" />
                    </div>
                    <div>
                      <h5 className="mb-1">{t("Document Name")} <span className="hic-required-mark" aria-hidden="true">*</span></h5>
                      <p className="mb-0 text-sm text-gray-600">{t("This PDF name will be visible to signing parties.")}</p>
                    </div>
                  </div>
                  <Row>
                    <Col lg={8}>
                      <Form.Group className="mb-0">
                        <Form.Label>{t("PDF file name")}</Form.Label>
                        <Form.Control
                          type="text"
                          id="documentName"
                          name="documentName"
                          placeholder={project?.p_name || t("Contract document name")}
                          value={validation.values.documentName }
                          onChange={validation.handleChange}
                        />
                      
                      </Form.Group>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row className="hic-contract-actions">
                <Col className="d-flex flex-column flex-md-row align-items-stretch align-items-md-center justify-content-between gap-3">
                  <div>
                    <div className="text-sm font-medium text-gray-900">{t("Ready to generate the document?")}</div>
                    <div className="text-sm text-gray-500">
                      {requiredRemaining > 0
                        ? `${requiredRemaining} ${t("required item(s) remaining")}`
                        : t("All required fields are complete.")}
                    </div>
                  </div>
                  <div className="d-flex flex-column flex-md-row gap-2">
                    {!project?.contract?.pc_contract_url ? (
                      <Button
                        type="button"
                        variant="outline-secondary"
                        disabled={loading || draftLoading}
                        onClick={handleSaveDraft}
                        className="inline-flex items-center justify-center w-full md:w-auto min-w-[160px]"
                      >
                        {draftLoading ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <FileText className="mr-2 h-4 w-4" />}
                        {draftLoading ? t("Saving Draft...") : t("Save as Draft")}
                      </Button>
                    ) : null}
                    <Button type="button" onClick={() => validation.handleSubmit()} variant="primary" disabled={loading || draftLoading} className="inline-flex items-center justify-center w-full md:w-auto min-w-[210px]">
                      {loading ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <FileText className="mr-2 h-4 w-4" />}
                      {loading ? t("Generating Document...") : t("Generate Contract Document")}
                    </Button>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      <LoaderModal />
      <ProcessingModal
        open={showStreamModal}
        currentStage={currentStage}
        extractedHTML={extractedHTML}
      />
      {/* <Toaster theme={'dark'} position="top-center" /> */}
  
      
    </React.Fragment>
  );
};

export default AddContract;
